import React from "react";
import { graphql, compose } from "react-apollo";
import {
  productByIDQuery,
  createNodeCartLineItem,
  createNodeCartLineItemWithSizes,
  currentUserCart,
  currencyById,
  currentUserQuery,
  getQuantitiesByRegion,
} from "../../queries";
import { withRouter } from "react-router";
import {
  AlertIcon,
  NumberField,
  Button,
  DropDown,
  SliderDetail,
  SnackBar,
  Message,
  ProductCard,
  Spinner,
} from "dab-component-lib";
import { ADD_ELEMENT } from "../../utils/constants";
import axios from "axios";
import _ from "lodash";
import I18n from "../../I18n/I18n";
import {
  BackStyle,
  GridContainerStyle,
  LoadingStyle,
  ErrorStyle,
  PageHeaderWrapperStyle,
} from "../../utils/style-utils";
import { getTotalByRegion } from "../../utils";
import {
  ProductRowStyle,
  ProductColStyle,
  TitleProductStyle,
  PackageTitleStyle,
  PriceStyle,
  FieldWrapperStyle,
  SelectWrapperStyle,
  AvailabilityStyle,
  IconWrapperStyle,
  ButtonWrapperStyle,
  FieldStyle,
  LabelStyle,
  DescriptionStyle,
  SnackBarWrapperStyle,
  PackageProductsStyle,
  PackageProductsTitleStyle,
} from "./style";

class ProductDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: "1",
      size: "",
      purchased: false,
      error: false,
      errorId: "",
      loading: false,
      errorQuantity: false,
    };
  }

  createNodeCartLineItem = async (targetIdProduct, quantity, size) => {
    const { createNodeCartLineItem, createNodeCartLineItemWithSizes } =
      this.props;
    let result = [];
    if (size) {
      result = await createNodeCartLineItemWithSizes({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
          size,
        },
      });
    } else {
      result = await createNodeCartLineItem({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
        },
      });
    }
    return result;
  };

  handleAddToCart = async (availability, max) => {
    const { currentUserCart, currencyById, match } = this.props;
    const { quantity, size } = this.state;
    this.setState({
      loading: true,
      error: false,
      errorId: "",
      errorQuantity: false,
    });
    let id = match.params.id;
    if (quantity <= availability && quantity <= max) {
      let nidObject = await this.createNodeCartLineItem(id, quantity, size);
      let nid = nidObject.data.createNodeCartLineItem.entity.nid;
      let currencyName = currencyById.nodeById.fieldCurrencyName;
      let uid = localStorage.getItem("currentUid");
      let res = {};
      if (
        !currentUserCart.error &&
        !currentUserCart.loading &&
        currentUserCart.currentusercartGraphql1View.results.length < 1
      ) {
        res = await axios.get(
          `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
        );
      } else {
        let cartId = currentUserCart.currentusercartGraphql1View.results[0].id;
        res = await axios.get(
          `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
        );
      }
      if (res.data.status === 1) {
        currentUserCart.refetch();
        this.setState({ loading: false, purchased: true });
      } else {
        this.setState({ loading: false, error: true, errorId: id });
      }
    } else {
      this.setState({ loading: false, errorQuantity: true });
    }
  };

  errorHandler() {
    if (this.state.errorQuantity) {
      return (
        <div>
          <Message
            description={I18n.t("errors.quantityPurchaseErrorDescription")}
            title={I18n.t("errors.quantityPurchaseError")}
          />
        </div>
      );
    }

    return (
      <div>
        <Message
          description={I18n.t("errors.purchaseErrorDescription")}
          title={I18n.t("errors.purchaseError")}
        />
      </div>
    );
  }

  getMax = (product) => {
    const { currentUserQuery, getQuantitiesByRegion } = this.props;
    if (
      !currentUserQuery.currentUserContext ||
      !getQuantitiesByRegion.filteredProductsGraphqlAmountxRegionView
    )
      return 0;
    let maxShop = product.fieldMaxShopQuantity;
    if (product.fieldPackageProductsRef.length > 0) {
      let av = this.getKitAvailability(product.fieldPackageProductsRef);
      return maxShop > av ? av : maxShop;
    }
    return maxShop > product.fieldAvailability
      ? product.fieldAvailability
      : maxShop;
  };

  getKitAvailability = (products) => {
    const { currentUserQuery, getQuantitiesByRegion } = this.props;
    let availability = 0;
    products.forEach((product, i) => {
      if (!getQuantitiesByRegion.filteredProductsGraphqlAmountxRegionView) {
        return 0;
      }
      if (i === 0 || product.entity.fieldAvailability < availability) {
        let quantityByRegion = getTotalByRegion(
          product.targetId.toString(),
          currentUserQuery.currentUserContext.fieldRegion,
          getQuantitiesByRegion.filteredProductsGraphqlAmountxRegionView.results
        );
        availability = quantityByRegion;
      }
    });
    return availability <= 0 ? 0 : availability;
  };

  handleGoToDetail = (id) => {
    const { history } = this.props;
    history.push(`/product-detail/${id}`);
  };

  openPdf = (pdfUrl) => {
    window.open(pdfUrl, "__blank");
  };

  render() {
    const {
      history,
      productByIDQuery: { loading, error, productById },
      currencyById,
      currentUserQuery,
      getQuantitiesByRegion,
    } = this.props;
    let sizes = [];
    let images = [];
    let price = {};
    let currencySign = null;

    if (!loading && !error) {
      if (productById === null) {
        return (
          <div>
            <Message
              description={I18n.t("errors.quantityPurchaseErrorDescription")}
              title={I18n.t("errors.productError")}
            />
          </div>
        );
      }

      productById.fieldSizes.forEach((size) => {
        sizes.push({
          label: size.entity.fieldSizeName,
          value: size.entity.fieldSizeName,
        });
      });
      productById.fieldProductImages.forEach((image) => {
        images.push({
          urls: {
            medium: image.url,
            small: image.url,
          },
        });
      });
      if (!currencyById.error && !currencyById.loading) {
        let currencyName = currencyById.nodeById.fieldCurrencyName;
        currencySign = currencyById.nodeById.fieldCurrencySign;
        price = _.find(
          productById.fieldPrices,
          (price) =>
            price.entity.fieldCurrency === (currencyName ? currencyName : "EUR")
        );
      }
    }
    let roles = {};
    if (!currentUserQuery.loading && !currentUserQuery.error) {
      roles = _.find(
        currentUserQuery.currentUserContext.roles,
        (role) => role.targetId === "visitor_customer"
      );
    }

    if (this.state.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }

    return (
      <GridContainerStyle>
        {(loading || getQuantitiesByRegion.loading) && (
          <LoadingStyle small>
            <Spinner size={150} />
          </LoadingStyle>
        )}
        {(error || getQuantitiesByRegion.error) && (
          <ErrorStyle>
            <h3>{I18n.t("errors.productError")}</h3>
          </ErrorStyle>
        )}
        {!loading &&
          !error &&
          !currencyById.error &&
          !currencyById.loading &&
          !getQuantitiesByRegion.error &&
          !getQuantitiesByRegion.loading && (
            <div>
              <PageHeaderWrapperStyle>
                <BackStyle onClick={() => history.goBack()}>
                  {I18n.t("buttons.back")}
                </BackStyle>
              </PageHeaderWrapperStyle>
              <ProductRowStyle>
                <ProductColStyle quarter>
                  <SliderDetail
                    alwaysOpenGallery={false}
                    images={images}
                    lang={
                      localStorage.getItem("language")
                        ? localStorage.getItem("language")
                        : "it"
                    }
                    openGallery={false}
                  />
                </ProductColStyle>
                <ProductColStyle>
                  <TitleProductStyle>
                    {productById.fieldCode
                      ? `${productById.fieldCode} - ${productById.name}`
                      : productById.name}
                  </TitleProductStyle>
                  {productById.fieldPackageProductsRef.length > 0 && (
                    <PackageTitleStyle>
                      {productById.fieldPackageProductsRef.length}{" "}
                      {I18n.t("content.articles")}
                    </PackageTitleStyle>
                  )}
                  {!roles &&
                    currentUserQuery.currentUserContext.uid !== 0 &&
                    localStorage.getItem("showPrices") === "true" && (
                      <PriceStyle>
                        {`${
                          price ? price.entity.fieldPriceAmount : "N/A"
                        } ${currencySign}`}
                      </PriceStyle>
                    )}
                  <FieldWrapperStyle>
                    <SelectWrapperStyle>
                      <div>
                        {productById.fieldPackageProductsRef === false && (
                          <div>
                            {productById.fieldSizes.length > 0 && (
                              <FieldStyle margin>
                                <LabelStyle>
                                  {I18n.t("productDetail.selectSize")}
                                </LabelStyle>
                                <DropDown
                                  disabled={false}
                                  expanded={false}
                                  id="button_id"
                                  onChange={({ value }) =>
                                    this.setState({ size: value })
                                  }
                                  options={sizes}
                                  placeholder={I18n.t(
                                    "productDetail.selectSize"
                                  )}
                                  selectedIndex={null}
                                  size="S"
                                  skin="secondary"
                                />
                              </FieldStyle>
                            )}
                          </div>
                        )}
                        <FieldStyle>
                          <LabelStyle>
                            {I18n.t("productDetail.quantity")}{" "}
                            <span>
                              {`(max ${
                                productById.fieldMaxShopQuantity
                              } ${I18n.t("productDetail.pieces")})`}
                            </span>
                          </LabelStyle>
                          <NumberField
                            id="quantityDetail"
                            max={this.getMax(productById)}
                            min={1}
                            name="quantity"
                            onChange={(event) =>
                              this.setState({
                                quantity: event.target.value.toString(),
                              })
                            }
                            required
                            value={this.state.quantity}
                          />
                        </FieldStyle>
                      </div>
                    </SelectWrapperStyle>
                    {productById.fieldPackageProductsRef === false && (
                      <AvailabilityStyle>
                        <IconWrapperStyle>
                          <AlertIcon
                            color="#004615"
                            color2="#f2f5f3"
                            size={34}
                          />
                        </IconWrapperStyle>{" "}
                        <LabelStyle>
                          {I18n.t("productDetail.availability")}:{" "}
                          <strong>{`${productById.fieldAvailability} ${I18n.t(
                            "content.pieces"
                          )}`}</strong>
                        </LabelStyle>
                      </AvailabilityStyle>
                    )}
                  </FieldWrapperStyle>
                  <ButtonWrapperStyle>
                    <Button
                      autoWidth={false}
                      disabled={
                        !price ||
                        currentUserQuery.currentUserContext.uid === 0 ||
                        (productById.fieldPackageProductsRef.length > 0
                          ? !this.getKitAvailability(
                              productById.fieldPackageProductsRef
                            )
                          : !productById.fieldAvailability) ||
                        !productById.fieldMaxShopQuantity
                      }
                      expanded={false}
                      icon="AddCartIcon"
                      id="addCartDetail"
                      label={I18n.t("buttons.addToCart")}
                      onClick={() =>
                        this.handleAddToCart(
                          productById.fieldAvailability,
                          productById.fieldMaxShopQuantity
                        )
                      }
                      outline={false}
                      size="M"
                    />
                  </ButtonWrapperStyle>
                  {this.state.purchased && (
                    <SnackBarWrapperStyle>
                      <SnackBar
                        action={{
                          label: I18n.t("buttons.goCheckout"),
                          onClick: () => history.push("/checkout"),
                        }}
                        text={I18n.t("content.addedItem")}
                      />
                    </SnackBarWrapperStyle>
                  )}
                  {((this.state.error &&
                    productById.id.toString() === this.state.errorId) ||
                    this.state.errorQuantity) &&
                    this.errorHandler()}
                  <div>
                    <LabelStyle bold>
                      {I18n.t("productDetail.description")}
                    </LabelStyle>
                  </div>
                  <div>
                    <DescriptionStyle
                      dangerouslySetInnerHTML={{
                        __html:
                          productById.fieldLongDescription &&
                          productById.fieldLongDescription.processed,
                      }}
                    />
                  </div>
                  <div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          productById.fieldReShoppableNote &&
                          productById.fieldReShoppableNote.processed,
                      }}
                    />
                  </div>
                  {productById.fieldPackageProductsRef.length > 0 && (
                    <PackageProductsStyle>
                      <PackageProductsTitleStyle>
                        {I18n.t("productDetail.detail")}:
                      </PackageProductsTitleStyle>
                      {productById.fieldPackageProductsRef.map((product, i) => {
                        return (
                          <ProductCard
                            abstract={product.entity.fieldAbstract.value}
                            availability={
                              product.entity.fieldAvailability >= 0
                                ? getTotalByRegion(
                                    product.entity.entityId.toString(),
                                    currentUserQuery.currentUserContext
                                      .fieldRegion,
                                    getQuantitiesByRegion
                                      .filteredProductsGraphqlAmountxRegionView
                                      .results
                                  )
                                : 0
                            }
                            disableCart
                            editable={false}
                            handleGoToDetail={() =>
                              this.handleGoToDetail(product.targetId)
                            }
                            handleOnClickPdf={
                              product.entity.fieldPdfProduct ||
                              product.entity.fieldLinkToPdf
                                ? () =>
                                    this.openPdf(
                                      product.entity.fieldPdfProduct
                                        ? product.entity.fieldPdfProduct.entity
                                            .url
                                        : product.entity.fieldLinkToPdf.url.path
                                    )
                                : null
                            }
                            hideCart
                            id={
                              product.entity.fieldCode
                                ? product.entity.fieldCode
                                : product.entity.entityId
                            }
                            key={i}
                            lang={
                              localStorage.getItem("language")
                                ? localStorage.getItem("language")
                                : "it"
                            }
                            maxQuantity={product.entity.fieldMaxShopQuantity}
                            name={product.entity.name}
                            noRegionSelected={
                              !currentUserQuery.currentUserContext.fieldRegion
                            }
                            photoUrl={
                              product.entity.fieldProductImages.length > 0
                                ? product.entity.fieldProductImages[0].url
                                : ""
                            }
                            quantity={1}
                            showAvailabilityAmount
                            showPrice={
                              localStorage.getItem("showPrices") === "true" &&
                              !_.find(
                                currentUserQuery.currentUserContext.roles,
                                (role) => role.targetId === "visitor_customer"
                              )
                            }
                          />
                        );
                      })}
                    </PackageProductsStyle>
                  )}
                </ProductColStyle>
              </ProductRowStyle>
            </div>
          )}
      </GridContainerStyle>
    );
  }
}

export default compose(
  graphql(productByIDQuery, {
    name: "productByIDQuery",
    options: ({ match }) => ({
      variables: {
        id: match.params.id,
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language").toUpperCase()
          : "IT",
      },
    }),
  }),
  graphql(currentUserCart, {
    name: "currentUserCart",
    options: () => ({
      variables: {
        id: localStorage.getItem("currentUid"),
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getQuantitiesByRegion, {
    name: "getQuantitiesByRegion",
    options: ({ match }) => ({
      variables: {
        field_product_category_target_id: null,
        id: {
          value: match.params.id,
        },
        name: localStorage.getItem("userRegion")
          ? localStorage.getItem("userRegion")
          : "ITALY",
      },
    }),
  }),
  graphql(currentUserQuery, {
    name: "currentUserQuery",
  }),
  graphql(createNodeCartLineItem, {
    name: "createNodeCartLineItem",
  }),
  graphql(createNodeCartLineItemWithSizes, {
    name: "createNodeCartLineItemWithSizes",
  }),
  graphql(currencyById, {
    name: "currencyById",
    options: () => ({
      variables: {
        id: localStorage.getItem("currency")
          ? localStorage.getItem("currency")
          : localStorage.getItem("defaultCurrency"),
      },
    }),
  })
)(withRouter(ProductDetail));



// WEBPACK FOOTER //
// ./src/components/productDetail/index.js